export enum ClockExtraType {
    SpecialHours = 0,
    Compensation = 1,
    CostItem = 2
}

export interface ClockExtraModel {
    id: string;
    description: string;
    type: ClockExtraType;
    amount: number;
    price: number;
    unitName?: string;
}

export interface WeekInfoModel {
    weekNumber: number;
    year: number;
}
